
import { defineComponent, SetupContext, getCurrentInstance, onMounted } from 'vue';
import { sendLog } from '@/common/radar';

const IncentiveEntryImage = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/incentive-pendant.gif';
const IncentiveCloseImage = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/incentive-close.png';

const IncentivePendant = defineComponent({
    props: {
        incentiveEntryImage: {
            type: String,
            default: IncentiveEntryImage,
        },
    },
    setup(_: unknown, ctx: SetupContext<Array<'onClose'>>) {
        const { proxy } = getCurrentInstance() || {};

        const handleClickPendant = () => {
            sendLog({
                type: 'click',
                name: 'WEB_FLOAT_PUPUP',
                value: {
                    click_area: 'detail',
                },
            });

            const IncentiveDomainMap: Record<string, string> = {
                'www.kwai.com': 'https://incentive.kwai.com',
                'www.snackvideo.com': 'https://incentive.kwai.com',
                'wwwt.kwai.com': 'https://kwai-incentive-encourage-pretest.test.gifshow.com',
                'kwai-pwa-hzs.test.gifshow.com': 'https://kwai-incentive-encourage.test.gifshow.com',
            };

            window.open(
                `${IncentiveDomainMap[window?.location?.host] || 'https://incentive.kwai.com'}/web/invitation?source=pwa_widget&countryInfo=${
                    proxy?.$store?.state?.startup?.bucket || 'br'
                }`
            );
        };

        const handleClose = () => {
            sendLog({
                type: 'click',
                name: 'WEB_FLOAT_PUPUP',
                value: {
                    click_area: 'close',
                },
            });
            ctx.emit('onClose');
        };

        onMounted(() => {
            sendLog({
                type: 'show',
                name: 'WEB_FLOAT_PUPUP',
                value: {},
            });
        });

        return {
            IncentiveEntryImage,
            IncentiveCloseImage,

            handleClickPendant,
            handleClose,
        };
    },
});

export default IncentivePendant;
